import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface NonAmendableWording {
  nonAmendableDetail: string
  nonAmendableLabel: string
  showNonAmendableWording: boolean
}

function useNonAmendableWording(isEligible: boolean): NonAmendableWording {
  const intl = useIntl()

  return useMemo(() => {
    return {
      showNonAmendableWording: isEligible,
      nonAmendableDetail: intl.formatMessage({
        id: 'VyHD32GOF9SGwwoBdAjq',
        defaultMessage: 'Please note that ’Non-Refundable and Non-Amendable’ packages are guaranteed at the time of booking and not eligible for a refund or date change. Accordingly, please select your package carefully and take note of any cancellation policy applicable to your purchase.',
      }),
      nonAmendableLabel: intl.formatMessage({
        id: 'iEahFEcRVkTQgjxdC2Q8',
        defaultMessage: 'Non-Refundable and Non-Amendable',
      }),
    }
  }, [intl, isEligible])
}

export default useNonAmendableWording
